import { ActionButton } from "./actionButton";
import { WebSocketManager } from "../../../helpers/webSocketManager";

export class AddOnBtn extends ActionButton {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param texture {string}
   * @param serverEventAddress {string}
   * @param gameObj {Phaser.GameObjects.Image}
   */
  constructor(scene, table, texture, serverEventAddress, gameObj) {
    super(scene, table, texture, serverEventAddress, false, gameObj);
    if (!table.isTournamentTable()) this.hide();
    this.table = table;
  }
  async onClick() {
    if (this.scene.isSceneObjectsInteractive) {
      await this.onClickTween();
      this.table.showTournamentAddOn(true, true);
    }
  }
}
